<template>
	<div class="row">
		<div class="col-12 col-lg-4">

			<div class="list-group bg-white shadow-sm">
				<a :class="channel == 'internal'
						? 'bg-white ' + listItemClasses
						: 'bg-lighter text-secondary ' + listItemClasses"
					@click.prevent="channel = 'internal'"
					href="#">
					Internal Discussion
					<span :class="this.internalChannelCommentsCount > 0
						? 'badge bg-primary rounded-pill'
						: 'badge bg-light rounded-pill text-muted'">
						{{ this.internalChannelCommentsCount }}
					</span>
				</a>
				<a :class="channel == 'creator'
						? 'bg-white ' + listItemClasses
						: 'bg-lighter text-secondary ' + listItemClasses"
					@click.prevent="channel = 'creator'"
					href="#">
					Creator Discussion
					<span :class="this.creatorChannelCommentsCount > 0
						? 'badge bg-primary rounded-pill'
						: 'badge bg-light rounded-pill text-muted'">
						{{ this.creatorChannelCommentsCount }}
					</span>
				</a>
				<a :class="channel == 'client'
						? 'bg-white ' + listItemClasses
						: 'bg-lighter text-secondary ' + listItemClasses"
					@click.prevent="channel = 'client'"
					href="#">
					Client Discussion
					<span :class="this.clientChannelCommentsCount > 0
						? 'badge bg-primary rounded-pill'
						: 'badge bg-light rounded-pill text-muted'">
						{{ this.clientChannelCommentsCount }}
					</span>
				</a>
			</div>

		</div>
		<div class="col-12 col-lg-8">

			<div class="card">
				<div class="card-header">
					<h4 class="card-header-title">{{ channelNameCapitalized }} Discussion</h4>
				</div>
				<div class="card-body mt-n4">

					<div v-if="isLoading" class="text-center p-5">
						<div class="spinner-border text-secondary" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					</div>
					<div v-else-if="filteredEvents.length" v-for="(event, index) in filteredEvents" :key="event.date">

						<div v-if="event.type == 'version'" class="my-4">
							<div class="small text-muted text-center">
								<span class="fw-bold">v{{ event.data.version }}</span>
								was uploaded {{ formatDate(event.data.created_at) }}
								by {{ event.data.uploader.name }}
							</div>
						</div>
						<div v-else-if="event.type == 'approval'" class="my-4">
							<div class="small text-muted text-center my-3">
								<span class="fw-bold">v{{ event.data.version }}</span>
								was approved {{ formatDate(event.data.approved_at) }}
							</div>
						</div>
						<div v-if="event.type == 'comment'" class="my-4">
							<comment
								:endpoint="this.creativeAssetEndpoint + '/comments'"
								:comment="event.data"
								@deleted="remove(event.data.id)"
							/>
						</div>

					</div>

					<!-- Divider -->
					<hr>

					<!-- Add Comment Form -->
					<div class="row">
						<div class="col-auto">

							<!-- Avatar -->
							<avatar :model="signedInUser" size="sm"/>

						</div>
						<div class="col ms-n2">

							<label class="visually-hidden">
								Leave a comment...
							</label>
							<textarea
								v-model="body"
								name="body"
								class="form-control form-control-flush"
								data-autosize
								rows="1"
								placeholder="Leave a comment"></textarea>

						</div>
						<div class="col-auto">

							<!-- Submit -->
							<button
								@click="addComment"
								class="btn btn-sm btn-white px-4 py-2 rounded-pill">
								Submit
							</button>

						</div>
					</div><!--/.row-->

				</div><!--/.card-body-->
			</div><!--/.card-->

		</div><!--/.col-->
	</div><!--/.row-->
</template>

<script>
	import autosize from 'autosize';
	import Avatar from '../Avatar.vue';
	import Comment from '../Comment.vue';

	import dayjs from 'dayjs';

	export default {

		props: ['creativeAssetData', 'creativeAssetEndpoint'],

		components: {
			'avatar': Avatar,
			'comment': Comment
		},

		data() {
			return {
				events: [],
				creativeAsset: this.creativeAssetData,
				body: '',
				channel: 'internal',
				signedInUser: window.App.user,
				isLoading: true,
				listItemClasses: 'list-group-item list-group-item-action d-flex justify-content-between'
			};
		},

		mounted() {
			var textareas = document.querySelectorAll('[data-autosize]')
			autosize(textareas);
			this.fetch();
		},

		computed: {

			filteredEvents() {
				var channel = this.channel;
				return this.events.filter(function (event) {
					return event.type != 'comment' || event.data.channel == channel;
				});
			},

			internalChannelCommentsCount() {
				return this.events.filter(function (event) {
					return event.type == 'comment' && event.data.channel == 'internal';
				}).length;
			},

			creatorChannelCommentsCount() {
				return this.events.filter(function (event) {
					return event.type == 'comment' && event.data.channel == 'creator';
				}).length;
			},

			clientChannelCommentsCount() {
				return this.events.filter(function (event) {
					return event.type == 'comment' && event.data.channel == 'client';
				}).length;
			},

			channelNameCapitalized() {
				return this.channel[0].toUpperCase() + this.channel.slice(1);
			},

		},

		methods: {

			formatDate(date) {
				return dayjs(date).format('MMM D, YYYY h:mma');
			},

			fetch() {
				this.isLoading = true;
				axios.get(this.creativeAssetEndpoint + '/events')
					.then((response) => {
						console.log(response.data);
						this.events = response.data;
						this.isLoading = false;
					})
					.catch((error) => {
						console.error(error);
					});
			},

			addComment() {
				axios.post(this.creativeAssetEndpoint + '/comments', {
					body: this.body,
					channel: this.channel
				}).then(({data}) => {

					this.body = '';

					console.log(data);

					// flash('Your reply has been posted.');

					this.events.push({
						date: data.created_at,
						type: 'comment',
						data: data
					});

					// window.scrollTo(0, document.body.scrollHeight);

					// resize textarea
					var textareas = document.querySelectorAll('[data-autosize]');
					textareas.forEach((textarea) => {
						textarea.style.height = '41px';
					});
				});

			},

			remove(commentId) {
				var events = this.events;
				console.log(events);
				this.events = events.filter(function (event) {
					return event.type != 'comment' || event.data.id != commentId;
				});
				this.$emit('removed');
			},

		}
	}
</script>
